const sizes = {
  container: ["48em"],
  wideContainer: ["54em"],
  sidebar: "300px",
  smallSidebar: "110px",
};

export default sizes;
